import { Image, Text } from '@ui/atoms';

import FdTexts from '@components/Products/FixedDeposits/en.json';

const texts = FdTexts.HeroSection;
const FeatureList = () => (
    <ul className="flex flex-col gap-4 md:gap-8 md:flex-row md:items-center mt-11 md:mt-0">
        {texts.steps.map((step, index) => (
            <li key={index} className="flex items-center gap-2">
                <Image
                    src={'/images/products/Star.svg'}
                    alt={texts.altText.starIcon}
                    className="w-4 h-4"
                />
                <Text
                    content={step}
                    className="text-gray-100 p6-medium"
                    isInnerHtml
                />
            </li>
        ))}
    </ul>
);

export default FeatureList;
